import { render, staticRenderFns } from "./CardsDashboard.vue?vue&type=template&id=6dc59710&"
import script from "./CardsDashboard.vue?vue&type=script&lang=js&"
export * from "./CardsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports